import { useSelector, useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import { clearError } from "./store/uiSlice";
import SocialBar from "./components/Navbar/SocialBar";
import { useEffect } from "react";
import { loadUser, verifySession } from "./store/authSlice";
import { Popup } from "./templates/Popup";
import usePageTracking from "./usePageTracking";
// import { useEffect } from "react";

function App() {
  const globalError = useSelector((state) => state.ui?.globalError);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if ("Notification" in window) {
  //     Notification.requestPermission().then((permission) => {
  //       if (permission === "granted") {
  //         new Notification("Welcome 🚀", {
  //           body: "Thanks for visiting our app!",
  //         });
  //       }
  //     });
  //   }
  // }, []);

  useEffect(() => {
    dispatch(loadUser()); // 🔑 Check if session exists
  }, [dispatch]);

  usePageTracking();

  return (
    <div className="App">
      <Navbar />

      {globalError && (
        <div
          className="bg-red-600 text-white text-center py-2 fixed top-16 w-full z-50 cursor-pointer"
          onClick={() => dispatch(clearError())}
        >
          {globalError}
        </div>
      )}
      <Popup />
      <Outlet />
      <SocialBar />
      <Footer />
    </div>
  );
}

export default App;
